import React, { Component } from 'react'

export class Franchise extends Component {
  render() {
    return (
      <div>Franchise</div>
    )
  }
}

export default Franchise